// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f75dca67","239":"13b2acd7","436":"9f1e7aea","453":"870cffd2","555":"8b72817f","656":"8b1e150f","770":"39571e4c","806":"cfde17d9"}[chunkId] + ".chunk.js";
};